// customStyles.js

export const fieldIconButtonStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 0,
    background: 'transparent',
    color: 'var(--app-color)',
    cursor: 'pointer',
    borderRadius: '10px',
    ':hover': {
      backgroundColor: '#F0F4F4',
      color: '#2b4252',
    },
    height: '58px',
  };
  
  export const fieldInputFieldStyle = (fieldKeysWithError = [], key = '') => ({
    width: '100%',
    '& .MuiInputBase-root': {
      height: 40,
      backgroundColor: 'white',
      border: fieldKeysWithError.includes(key) ? '1px solid red' : 'inherit',
    },
    '& .MuiOutlinedInput-input': {
      height: 40,
      width: '100%',
      border: fieldKeysWithError.includes(key) ? '1px solid red' : 'inherit',
    },
  });


  export const fieldCheckboxFieldStyle = (fieldKeysWithError = [], key = '') => {
    return {
      p: 0,
      m: 0,
      ml: '2px',
      height: '10px',
      width: '10px',
      '& .MuiSvgIcon-root': { fontSize: '30px' },
      borderColor: fieldKeysWithError.includes(key) ? 'red' : 'inherit',
    };
  };
  
  export const fieldTabButtonStyle = {
    color: '#2b4252',
    minWidth: '100px',
    marginRight: '10px',
    padding: '15px',
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: 'var(--tab-button-color)',
    textTransform: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(43, 66, 82, 0.1)',
    },
    '&.Mui-disabled': {
      color: 'grey',
    },
    '& .MuiButton-startIcon': {
      marginRight: '2px',
    },
  };

export const sectionButtonStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 0,
  background: 'transparent',
  color: 'var(--icon-button-color-green)',
  cursor: 'pointer',
  borderRadius: '10px',
  ':hover': {
    backgroundColor: '#F0F4F4',
    color: 'var(--icon-button-color-green)',
  },
  height: '58px'
};


export const fieldTabButtonStyleGreen = {
  color: 'white',                     // white text
  minWidth: '100px',
  marginRight: '10px',
  padding: '15px',
  paddingTop: 0,
  paddingBottom: 0,
  backgroundColor: 'green',          // solid green background
  textTransform: 'none',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'lightgreen',   // light green on hover
  },
  '&.Mui-disabled': {
    backgroundColor: '#e0e0e0',
    color: '#9e9e9e',
  },
  '& .MuiButton-startIcon': {
    marginRight: '2px',
  },
};

export const signUpButtonStyle = {
                        mt: 3,
                        mb: 1,
                        width: '345px',
                        backgroundColor: 'var(--button-color)',
                        color: 'white',
                        fontWeight: 'normal',
                        textTransform: 'none',
                        ":hover": {
                          backgroundColor: 'var(--button-hover-color)',
                        },
                      };


export const removeButtonStyle = {
              backgroundColor: 'var(--button-color-red)',
              color: 'white',
              width: '130px',
              ":hover": {
                  backgroundColor: 'var(--button-hover-color)',
              },
              '&.Mui-disabled': {
                  backgroundColor: '#e0e0e0',
                  color: 'grey',
              },
            };

export const updateButtonStyle = {
                  marginRight: '10px',
                  backgroundColor: 'var(--app-color)',
                  width: '130px',
                  ":hover": {
                      backgroundColor: 'var(--button-hover-color)',
                  },
                  '&.Mui-disabled': {
                      backgroundColor: '#e0e0e0',
                      color: 'grey',
                  },
                  };



export const sectionMoveArrows = {
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: 0,
                  background: 'transparent',
                  color: 'var(--app-color)',
                  cursor: 'pointer',
                  borderRadius: '10px',
                  ':hover': {
                    backgroundColor: 'transparent',
                    color: 'var(--button-hover-color)',
                  },
                  height: '30px'
                };